function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var MobileNav = /*#__PURE__*/function () {
  function MobileNav() {
    _classCallCheck(this, MobileNav);
    this.toggleMenu();
    MobileNav.subMenus();
    console.log('MobileNav loaded');
  }
  _createClass(MobileNav, [{
    key: "toggleMenu",
    value: function toggleMenu() {
      var _this = this;
      var hamburger = document.getElementById('MobMenuToggle');
      var searchTrigger = document.getElementById('MobSearchToggle');
      var searchForm = document.getElementById('SearchForm');
      var menu = document.getElementById('MobMenu');
      if (hamburger) {
        hamburger.addEventListener('click', function () {
          if (!hamburger.classList.contains('hamburger--active')) {
            _this.openMenu(hamburger, menu);
            searchForm.classList.remove('l-header__search--open');
          } else {
            _this.closeMenu(hamburger, menu);
          }
        });
      }
      if (searchTrigger) {
        var searchInput = document.getElementById('SearchTerms');
        searchTrigger.addEventListener('click', function () {
          if (!searchForm.classList.contains('l-header__search--open')) {
            // Add open state classes
            searchForm.classList.add('l-header__search--open');
            searchInput.focus();
            _this.closeMenu(hamburger, menu);
          } else {
            // Remove open state classes
            searchForm.classList.remove('l-header__search--open');
          }
        });
      }
    }
  }, {
    key: "openMenu",
    value: function openMenu(hamburger, menu) {
      this.scrollPos = window.pageYOffset;
      window.scroll(0, 0);
      document.body.classList.add('is-locked');

      // Remove closed state classes
      menu.classList.remove('mob-nav--closed');

      // Add open state classes
      hamburger.classList.add('hamburger--active');
      menu.classList.add('mob-nav--open');
    }
  }, {
    key: "closeMenu",
    value: function closeMenu(hamburger, menu) {
      document.body.scrollTop = this.scrollPos;
      document.body.classList.remove('is-locked');
      window.scroll(0, this.scrollPos);

      // Add closed state classes
      menu.classList.add('mob-nav--closed');

      // Remove open state classes
      menu.classList.remove('mob-nav--open');
      hamburger.classList.remove('hamburger--active');
    }
  }], [{
    key: "subMenus",
    value: function subMenus() {
      var parentTriggers = Array.from(document.querySelectorAll('.mob-nav__trigger--parent'));
      parentTriggers.forEach(function (trigger) {
        trigger.addEventListener('click', function () {
          var triggerMenu = trigger.dataset.menu;
          var childrenMenus = Array.from(document.querySelectorAll('.mob-nav__menu--children'));
          childrenMenus.forEach(function (child) {
            var childMenu = child.dataset.menu;
            if (triggerMenu === childMenu) {
              child.classList.add('mob-nav__menu--open');
              child.classList.remove('mob-nav__menu--closed');
            }
          });
        });
      });
      var backTriggers = Array.from(document.querySelectorAll('.mob-nav__trigger--back'));
      backTriggers.forEach(function (trigger) {
        trigger.addEventListener('click', function () {
          var triggerMenu = trigger.dataset.menu;
          var childrenMenus = Array.from(document.querySelectorAll('.mob-nav__menu--children'));
          childrenMenus.forEach(function (child) {
            var childMenu = child.dataset.menu;
            if (triggerMenu === childMenu) {
              child.classList.remove('mob-nav__menu--open');
              child.classList.add('mob-nav__menu--closed');
            }
          });
        });
      });
    }
  }]);
  return MobileNav;
}();
export { MobileNav as default };